export const PRESENCE_THRESHOLDS_MS = {
    live: 90_000,
    recent: 5 * 60_000,
    fading: 15 * 60_000,
    stale: 45 * 60_000
};
export function stalenessBucket(ageMs) {
    if (ageMs < PRESENCE_THRESHOLDS_MS.live)
        return 'live';
    if (ageMs < PRESENCE_THRESHOLDS_MS.recent)
        return 'recent';
    if (ageMs < PRESENCE_THRESHOLDS_MS.fading)
        return 'fading';
    if (ageMs < PRESENCE_THRESHOLDS_MS.stale)
        return 'stale';
    return 'last-seen';
}
export function formatPresenceAge(ageMs) {
    if (ageMs < 60_000)
        return 'just now';
    const minutes = Math.floor(ageMs / 60_000);
    if (minutes < 60)
        return `${minutes}m ago`;
    return `${Math.floor(minutes / 60)}h ago`;
}
